import React, {
  useRef,
  useMemo,
  useState,
  useCallback,
  ReactNode,
} from "react";
import { withRouter } from "react-router-dom";

import {
  ActionToolbar,
  DialogWithActions,
  EditButton,
  GqlTable,
} from "../../components";

import { Button, Container } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";

import { QUERIES } from "../../../graphql";
import { Contact } from "../../../graphql/models";
import { ContactEditForm } from "./contacts_form";

import useContactsStyle from "./contacts.style";
import { useLoggedUserInfo } from "../../../hooks";
//import { useUserState } from '../../../context';

function ContactsPage(props: any) {
  const classes = useContactsStyle();

  const tableRef = useRef();

  //const { userRole } = useUserState();
  const [formDialogOpened, setFormDialogOpened] = useState(false);
  const [formContact, setFormContact] = useState<Contact | undefined>(void 0);

  const addNewContact = () => {
    setFormContact({} as Contact);
    setFormDialogOpened(true);
  };

  const editContact = (row) => {
    setFormContact({
      ...row,
    });
    setFormDialogOpened(true);
  };

  const onValueUpdatedSuccessfully = () => {
    setFormContact(void 0);
    setFormDialogOpened(false);
    (tableRef as any).current?.refresh();
  };

  const onValueDeleted = () => {
    setFormContact(void 0);
    setFormDialogOpened(false);
    (tableRef as any).current?.refresh();
  };

  const gqlTableRowActions = useCallback((row: Contact) => {
    const actions: ReactNode[] = [];
    actions.push(<EditButton onClick={() => editContact(row)} />);

    return actions;
  }, []);

  const actionToolbarActions = useMemo(() => {
    const actions: any[] = [];
    actions.push(
      <Button
        key="addNewContact"
        variant="contained"
        color="primary"
        onClick={() => addNewContact()}
      >
        Aggiungi Nuovo
      </Button>
    );

    return actions;
  }, []);

  const { isAdminUser } = useLoggedUserInfo();

  const tableActions = useMemo(() => {
    const columns = ["", "Titolo", "Indirizzi email", "Numeri di telefono"];
    if (isAdminUser) {
      columns.push("Palazzi");
    }

    return columns;
  }, [isAdminUser]);

  return (
    <Container className={classes.container} maxWidth={false} component="div">
      <>
        <ActionToolbar title={"Numeri utili"} actions={actionToolbarActions} />
        <GqlTable
          ref={tableRef}
          columns={[...tableActions].map((v) => (
            <TableCell>{v}</TableCell>
          ))}
          query={QUERIES.CONTACTS}
          queryResultDataField="contacts"
          rows={(row: Contact) => (
            <>
              <TableCell>{gqlTableRowActions(row)}</TableCell>
              <TableCell>{row.label}</TableCell>
              <TableCell>{row.emailAddresses?.join(", ")}</TableCell>
              <TableCell>{row.phoneNumbers?.join(", ")}</TableCell>
              {isAdminUser && (
                <TableCell>
                  {row.buildings.map((v) => v.code).join(", ")}
                </TableCell>
              )}
            </>
          )}
        />
        <DialogWithActions
          fullScreen
          open={formDialogOpened}
          setOpen={setFormDialogOpened}
          title={"Aggiungi / Modifica contatto"}
        >
          <ContactEditForm
            value={formContact}
            onValueUpdatedSuccessfully={onValueUpdatedSuccessfully}
            onValueDeleted={onValueDeleted}
          />
        </DialogWithActions>
      </>
    </Container>
  );
}

export default withRouter(ContactsPage);
